import React, { useState } from "react";
import axios from "axios";
import { useNavigate, Link } from "react-router-dom";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import SubscriptionPopup from "../SubscriptionPopup";

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [showSubscriptionPopup, setShowSubscriptionPopup] = useState(false);
  const [storedEmail, setStoredEmail] = useState("");
  const navigate = useNavigate();
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrors({});
    setLoading(true);
    setStoredEmail(email);

    try {
      const response = await axios.post(`${API_BASE_URL}/login`, {
        email,
        password,
      });


      localStorage.setItem("token", response.data.token);
      if (response.data.subscription_status === "Expired") {

        localStorage.setItem("subscription", "Expired");
        setShowSubscriptionPopup(true);
      } else {

        localStorage.setItem("subscription", "Active");
      }

      navigate("/dashboard");
    } catch (err) {
      if (err.response) {
        if (
          err.response.status === 403 &&
          err.response.data.login_subscription === "Expired"
        ) {

          localStorage.setItem("subscription", "Expired");
          setShowSubscriptionPopup(true);
        } else if (err.response.data.invalid) {
          setErrors({ ...errors, invalid: err.response.data.invalid });
        } else if (
          err.response.data.args &&
          Array.isArray(err.response.data.args)
        ) {
          const validationErrors = err.response.data.args[0];
          setErrors(validationErrors);
        }
      } else {
        setErrors({ general: "An error occurred. Please try again later." });
      }
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "email") {
      setEmail(value);
      setErrors((prevErrors) => ({ ...prevErrors, email: undefined }));
    } else if (name === "password") {
      setPassword(value);
      setErrors((prevErrors) => ({ ...prevErrors, password: undefined }));
    }
  };

  const handleExtend = () => {
    window.open("https://localshouts.com", "_blank");
  };

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("subscription");
    setShowSubscriptionPopup(false);
    setEmail(storedEmail);
    setPassword("");
    navigate("/");
  };

  return (
    <div className="container">
      <div className="login-page">
        <div className="form rounded-4 white-box-shadow">
          <form className="login-form" onSubmit={handleSubmit}>
            <div className="login-logo">
              <img
                src={`${process.env.PUBLIC_URL}/assets/img/logo.png`}
                alt="Logo"
                style={{ width: "180px" }}
              />
            </div>

            <div className="form-group">
              <div className="form-field position-relative">
                <i className="fa-regular fa-user"></i>
                <input
                  className="form-control"
                  type="email"
                  name="email"
                  value={email}
                  placeholder="Email or Username"
                  onChange={handleChange}
                />
                {errors.email && (
                  <p className="error-message">{errors.email[0]}</p>
                )}
              </div>
            </div>

            <div className="form-group mt-3">
              <div className="form-field" style={{ position: "relative" }}>
                <i className="icon-plock"></i>
                <input
                  className="form-control"
                  type={showPassword ? "text" : "password"}
                  name="password"
                  value={password}
                  placeholder="Password"
                  onChange={handleChange}
                />
                <span
                  onClick={() => setShowPassword((prev) => !prev)}
                  style={{
                    position: "absolute",
                    right: "10px",
                    top: "15px",
                    cursor: "pointer",
                    color: "gray",
                  }}
                >
                  {showPassword ? <FaEye size={20} /> : <FaEyeSlash size={20} />}
                </span>
                {errors.password && (
                  <p className="error-message">{errors.password[0]}</p>
                )}
                {errors.invalid && (
                  <p className="error-message">{errors.invalid}</p>
                )}
              </div>
            </div>

            <div className="form-group form-btns mt-3">
              <div className="form-field" style={{ position: "relative" }}>
                <button type="submit" disabled={loading} className="ls-btn">
                  {loading ? "Logging in..." : "Login now"}
                </button>

                {showSubscriptionPopup && (
                  <SubscriptionPopup onExtend={handleExtend} onLogout={handleLogout} />

                )}
              </div>
            </div>

            <div>
              <p className="message">
                <Link to="/forgotpassword">Forgot Password?</Link>
              </p>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Login;
